import { render, staticRenderFns } from "./NsCreditCard.vue?vue&type=template&id=8cb00a64&scoped=true&"
import script from "./NsCreditCard.vue?vue&type=script&lang=js&"
export * from "./NsCreditCard.vue?vue&type=script&lang=js&"
import style0 from "./NsCreditCard.vue?vue&type=style&index=0&id=8cb00a64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb00a64",
  null
  
)

export default component.exports